import classNames from 'classnames'
import { GameData } from 'web/data/models'

type WowheadLinkProps = {
    gameData: GameData

    disableLeftClick?: boolean
    className?: string

    children: JSX.Element
}

export const WowheadLink = (props: WowheadLinkProps): JSX.Element | null => {

    const { game_id, link_suffix } = props.gameData

    if (game_id == null) {
        return props.children
    }

    return (
        <a
            className={classNames(
                "no-link-styling",
                { "cursor-default": props.disableLeftClick },
                props.className
            )}
            target="_blank"
            rel="noopener noreferrer"
            href={`https://www.wowhead.com/spell=${game_id}${link_suffix ?? ''}`}
            data-wh-icon-added={false}
            onClick={(e) => {
                if (props.disableLeftClick) {
                    // Prevents opening with left-mouse, only middle-mouse
                    // will work
                    e.preventDefault()
                }
            }}
        >
            {props.children}
        </a>
    )
}
